/**
 * @voltxampere/ui — SPDT mechanical relay 5V coil (Sprint 44-5, placeholder)
 *
 * PLACEHOLDER. Mekanik SPDT röle — Arduino-driven hobbyist
 * standardı. Coil 5V DC / 70 mA + 1 ortak + 1 NO + 1 NC contact.
 * Coil current threshold → contact state coupling Sprint 47+
 * engine extension #4 ile.
 *
 * Reference: Tyco/Omron G5LE-1-5DC — PCB-mount. Coil 5 V DC,
 * 70 mA pickup. Contact 10 A @ 250 VAC / 12 A @ 30 VDC. SPDT
 * (1 NO + 1 NC). Standart "Arduino röle modülü" işin kalbi.
 *
 * Engine zero-diff invariant honored — canonical `switch` engine
 * type via schemaType (output contacts SPST shown; SPDT 3-pin
 * Sprint 47+'da).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { switchSymbol } from "../switch.js";
export const relaySpdt5v = {
    id: "relay-spdt-5v",
    nameTr: "Röle SPDT 5V Coil (Omron G5LE-1-5DC, placeholder)",
    nameEn: "Relay SPDT 5V Coil (Omron G5LE-1-5DC, placeholder)",
    shortcut: "S",
    category: "passive",
    viewBox: switchSymbol.viewBox,
    terminals: switchSymbol.terminals,
    defaultLabel: "K",
    defaultValue: "SPDT-5V",
    schemaType: "switch",
    defaultParams: { closed: false, Ron: 1e-3, Roff: 1e9 },
    renderSVG: () => switchSymbol.renderSVG(),
};
//# sourceMappingURL=relay-spdt-5v.js.map